import * as React from 'react'
import { useState } from 'react';
import { Form, Card, Modal, Button } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import { useApprovedContext } from '../../contexts/ApprovedContext';
import { UserClaimable } from '../../contexts/ContextTypes';

export default function ProfileInformation() {
  const { currentUser, currentUserInfo, updateCurrentUserInfo } = useAuth();
  const { setDriver, setSolo, setMaxPassengerCount, setPhoneNumber } = useApprovedContext();
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [showSoloModal, setShowSoloModal] = useState(false);

  async function phoneNumberChangedHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const phoneNumber = event.currentTarget.value;
    if (phoneNumber === undefined) return;

    await setPhoneNumber(phoneNumber);
    updateCurrentUserInfo();
    console.log(currentUserInfo)
  }

  async function openDriverModal() {
    //setDriver(!currentUserInfo?.isDriver);
    //updateCurrentUserInfo();
    if (currentUserInfo?.isDriver) {
      setDriver(false);
      updateCurrentUserInfo();
    } else {
      setShowDriverModal(true);
    }
  }

  function closeDriverModalCancel() {
    setShowDriverModal(false);
  }

  // function closeDriverModalAccept() {
  //   // setDriver(true);
  //   // updateCurrentUserInfo();
  //   setShowDriverModal(false);
  // }

  async function openSoloModal() {
    if (   currentUserInfo?.solo === UserClaimable.claimedNotApproved 
        || currentUserInfo?.solo === UserClaimable.claimedAndApproved
    ) {
      setSolo(UserClaimable.notClaimed);
      updateCurrentUserInfo();
      return;
    } 

    if (   currentUserInfo?.solo === UserClaimable.notClaimed
        || currentUserInfo?.solo === undefined
    ) {
      setShowSoloModal(true);
      return
    }
  }

  function closeSoloModalCancel() {
    setShowSoloModal(false);
  }

  function closeSoloModalAccept() {
    setSolo(UserClaimable.claimedNotApproved);
    updateCurrentUserInfo();
    setShowSoloModal(false);
  }

  async function passengerCountChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const newCount = parseInt(event.currentTarget.value);
    if (newCount === undefined) return;

    await setMaxPassengerCount(newCount);
    updateCurrentUserInfo();
  }

  return (
    <Card style={{ width: "21em" }}>
      <Card.Header>
        <h2>Profile Information</h2>
      </Card.Header>
      <Card.Body>
        <Form className='correctly-margined-form'>
          <Form.Group id="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              defaultValue={currentUser && currentUser.email ? currentUser.email : ""}
              disabled
            />
          </Form.Group>
          <Form.Group id="phone">
            <Form.Label>Phone Number:</Form.Label>
            <Form.Control
              type="tel"
              defaultValue={currentUserInfo && currentUserInfo.phoneNumber ? currentUserInfo.phoneNumber : ""}
              onChange={phoneNumberChangedHandler}
            />
          </Form.Group>
          <Form.Group id="driver" className='pt-3 row'>
            <Form.Check
              checked={currentUserInfo?.isDriver}
              onChange={openDriverModal}
              className='col-1'
            />
            <Form.Label
              onClick={openDriverModal}
              className='col-11'
            >
              Is Driver?
            </Form.Label>
          </Form.Group>
          <Form.Group id="driver" className='pt-3' hidden={!currentUserInfo?.isDriver}>
            <Form.Label>Passenger capacity (excl driver)</Form.Label>
            <Form.Control
              type='number'
              value={currentUserInfo?.passengerCount}
              min={0}
              onChange={passengerCountChanged}
            />
          </Form.Group>
          <Form.Group id="solo" className='pt-3 row'>
            <Form.Check
              checked={currentUserInfo?.solo === UserClaimable.claimedAndApproved || currentUserInfo?.solo === UserClaimable.claimedNotApproved}
              onChange={openSoloModal}
              className='col-1'
            />
            <Form.Label
              onClick={openSoloModal}
              className='col-11'
            >
              Is Solo? {currentUserInfo?.solo === UserClaimable.claimedNotApproved ? "(Awaiting approval...)" : ""}
            </Form.Label>
          </Form.Group>
        </Form>
      </Card.Body>

      <Modal show={showDriverModal} onHide={closeDriverModalCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Becoming an SUGC Rideshare Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          To become a driver for SUGC, please contact one of our committee members at <a href="mailto:gliding@soton.ac.uk">gliding@soton.ac.uk</a> so you can be appropriatly briefed.
          {
          // By enabling your driver status with SUGC, you confirm:
          // <ul>
          //   <li>I have been briefed on driving on an airfield</li>
          //   <li>I have a valid UK drivers licence</li>
          //   <li>I will keep my car insured and within MOT when using it for SUGC</li>
          //   <li>My car insurance may not cover me while on the airfield</li>
          //   <li>Even though I have my own transport, I still need to be assigned to a flying list to be permitted to fly at Shalbourne</li>
          //   <li>I am allowed to ask my passengers for £5 each to cover fuel costs</li>
          //   <li>My phone number will be given to my passengers when they are assigned to a flying list with me as the driver, so that they can contact me to confirm attendance</li>
          // </ul>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeDriverModalCancel}>
            Ok
          </Button>
          {
          // <Button variant="primary" onClick={closeDriverModalAccept}>
          //   Accept
          // </Button>
          }
        </Modal.Footer>
      </Modal>

      <Modal show={showSoloModal} onHide={closeSoloModalCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Shalbourne Solo Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          By declaring solo status to SUGC, you confirm that you have:
          <ol>
            <li>completed your BGA Solo rating and obtained an FAI Gliding Certificate, and</li>
            <li>flown solo at least once at Shalbourne.</li>
          </ol>
          <p className='mb-1'>Currency is not considered here.</p>
          <p>Acceptance of this confirmation does not constitute permission to fly solo at Shalbourne.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeSoloModalCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={closeSoloModalAccept}>
            I Confirm
          </Button>
        </Modal.Footer>
      </Modal>

    </Card>
  )
}
